import { useParams } from 'react-router'
import ClinicBrandPayoutInvoiceReceipts from 'src/supportPortal/components/common/clinics/payoutInvoice/ClinicBrandPayoutInvoiceReceipts'

export default function ClinicBrandPayoutInvoices() {
  const { brandSlug } = useParams()

  return <ClinicBrandPayoutInvoiceReceipts clinicBrandSlug={brandSlug} />
}
